import styled from 'styled-components';
import image from './../../_static/others/ballons.jpg';

export const MembershipPageBackgroud = styled.div`
    width: 100%;
    height: 100vh;
    margin: 0;
    top: 0;
    left: 0;
    background: url(${image}) center center no-repeat;
    background-size: cover;    
`;

export const UserDataConfigurationBox = styled.div`
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    
     .card {
          min-height: 600px;
          max-height: 700px;
    }
`;

export const PersonalDataStepBox = styled.div`
    height: 450px;
`;

export const MembershipStepBox = styled.div`
    height: 450px;
    
    #membership-reef-form {
        height: 100%;
    }
    
    span {
        color: #0070f3;
    }
`;

export const SaveOnResortStepBox = styled.div`
    height: 450px;
    
    #save-on-resort-reef-form {
        height: 100%;
    }
`;